"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _exportNames = {
  Image640: true
};
exports.Image640 = void 0;
var _image = _interopRequireDefault(require("./components/image-640"));
exports.Image640 = _image["default"];
var _image2 = require("./components/image-640.propTypes");
Object.keys(_image2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _image2[key]) return;
  exports[key] = _image2[key];
});